export const g4Element = (elementName, elementId, pageId, options?: any) => {
  try {
    const userMessage = localStorage.getItem("userMessage");

    let params = {
      user_id: !!userMessage ? JSON.parse(userMessage)?.mId : "",
      element_id: elementId,
      page_id: pageId,
      page: pageId,
      device_id: localStorage.getItem("UUID"),
      sub_platform: "PC",
    };

    if (!!options) {
      params = { ...params, ...options };
    }
    window.gtag("event", elementName, params);
  } catch (e) {
    console.log(e);
  }
};

/** GA埋点 - 新版 */
export const g4 = (elementName: string, options: { [k: string]: any }) => {
  try {
    const userMessage = localStorage.getItem("userMessage");
    let params = {
      user_id: !!userMessage ? JSON.parse(userMessage).mId : "",
      device_id: localStorage.getItem("uuid"),
      sub_platform: "PC",
    };
    window.gtag("event", elementName, { ...params, ...options });
  } catch (e) {
    console.log(e);
  }
};

/**
 * @description 数字千分位
 * @param {Array | number} num
 * @returns {boolean}
 */
export function formatThousend(num: number | string): string {
  if (Number(num) > 10000) {
    return `${(Number(num) / 10000).toFixed(1)}萬`;
  }

  var reg = /\d{1,3}(?=(\d{3})+$)/g;
  return (num + "").replace(reg, "$&,");
}

// 視頻時長長度＜60分鐘，顯示分秒00:00
// 視頻時長長度＞60分鐘，顯示時分秒0:00:00
export function formatVideoDuration(durationInSeconds: number | string) {
  const timeFormat = /^(\d{1,2}):(0[0-9]|[1-5][0-9]):(0[0-9]|[1-5][0-9])$/;
  const shortTimeFormat = /^(0[0-9]|[1-5][0-9]):(0[0-9]|[1-5][0-9])$/;

  // 如果输入是字符串且符合时间格式，直接返回
  if (
    typeof durationInSeconds === "string" &&
    (timeFormat.test(durationInSeconds) || shortTimeFormat.test(durationInSeconds))
  ) {
    return durationInSeconds;
  }

  if (typeof durationInSeconds === "number") {
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = Math.floor(durationInSeconds % 60);

    if (hours > 0) {
      return `${hours}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    } else {
      return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    }
  }

  return "";
}

export function findRegionName({ regionId, data }) {
  let regionName = "";

  for (const region of data) {
    for (const item of region.items) {
      if (`${item.value}` === `${regionId}`) {
        regionName = item.name;
        break;
      }
    }
  }

  return regionName;
}
